<template>
    <div class="section">
        <div class="container">
            <div class="columns is-centered">
                <div class="column">
                    <router-view class="lb-alternative-font" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    computed: {},
    watch: {},
};
</script>
